import config from '../../config'
import { useCallback, useMemo } from 'react'
import axios from 'axios'
import { useMutation } from '@tanstack/react-query'

import { IUseUpdateMutation, IDeleteFn, IChecklistTemplate, IGetPutRequest } from '../../interfaces'

const getToggleActiveChecklistTemplateRequest: IGetPutRequest = params => {
  const { airportId } = params;
  return {
    method: 'put',
    url: `${config.baseUrl}/${airportId}/Checklists/templates/`,
  }
}

const useToggleActiveChecklistTemplateMutation: IUseUpdateMutation<IChecklistTemplate, number> = (params, options = {}) => {
  const request = useMemo(() => getToggleActiveChecklistTemplateRequest(params), [params])

  const updateChecklistTemplate: IDeleteFn<IChecklistTemplate> = useCallback(
    async id => axios({ ...request, url: request.url + id + '/toggle-is-active' }).then(res => res.data),
    [request],
  )

  const response = useMutation<IChecklistTemplate, Error, any>({ mutationFn: updateChecklistTemplate, ...options })

  return response
}

export default useToggleActiveChecklistTemplateMutation
